import { Routes } from '@angular/router';
import {
  cmsInEditorGuard,
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';
import { authGuard } from '@self-fix/data-access';
import { hasSelectedApplianceGuard } from '@self-fix/feature-your-appliance';
import {
  loadPlansGuard,
  assistanceGuard,
} from '@self-fix/feature-appliance-details';
import { AppConfig } from 'apps/dg-self-fix/src/app/models/config/app-config.type';

export const cmsRouting = {
  component: CmsPageComponent,
  resolve: {
    cmsPageTemplate: cmsPageTemplateResolver,
    seoData: cmsSeoDataResolver,
  },
};

export const getSmartFixRoutes = (environment: AppConfig): Routes => [
  {
    path: '',
    pathMatch: 'full',
    ...cmsRouting,
    canActivate: [
      cmsInEditorGuard,
      environment.hasAuthGuard && authGuard,
      environment.hasPlanSelection && loadPlansGuard,
    ].filter((val) => val),
    data: {
      cmsNodePath: '/',
      redirectTo: '/appliance-details',
    },
  },
  {
    path: 'your-appliance',
    ...cmsRouting,
    canActivate: [
      environment.hasAuthGuard && authGuard,
      environment.hasPlanSelection && loadPlansGuard,
      hasSelectedApplianceGuard,
      environment.hasPlanSelection && assistanceGuard,
    ].filter((val) => val),
  },
  {
    path: 'appliance-details',
    ...cmsRouting,
    canActivate: [
      environment.hasAuthGuard && authGuard,
      environment.hasPlanSelection && loadPlansGuard,
    ].filter((val) => val),
  },
  {
    path: ':category',
    ...cmsRouting,
    canActivate: [environment.hasAuthGuard && authGuard].filter((val) => val),
  },
  {
    path: '**',
    ...cmsRouting,
    canActivate: [environment.hasAuthGuard && authGuard].filter((val) => val),
  },
];
